<template>
  <div style="padding:14px 10px">
    <!-- 面包屑导航 -->
    <div class="cur_route">{{$route.name}}</div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/index' }">Dashboard</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Search筛选 -->
    <el-form :inline="true" :model="params" class="user-search">
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="Loading..."
      style="width: 1122px;">
      <el-table-column prop="country" label="Country" align="center" width="100">
      </el-table-column>
      <el-table-column prop="area_code" label="Area Code" align="center" width="100">
      </el-table-column>
      <el-table-column prop="currency" label="Currency" align="center" width="100">
      </el-table-column>
      <el-table-column prop="time_difference" label="TimeDiff" align="center" width="100">
      </el-table-column>
      <el-table-column prop="lang" label="Language" align="center" width="120">
      </el-table-column>
      <el-table-column prop="app_version" label="Version" width="100">
      </el-table-column>
      <el-table-column prop="download_url" label="Download Url" width="400">
      </el-table-column>
      <el-table-column align="center" label="Action" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- Edit界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="Country" prop="country">
          <el-input size="small" v-model="editForm.country" auto-complete="off" placeholder="Country" disabled>
          </el-input>
        </el-form-item>
        <el-form-item label="Version" prop="app_version">
          <el-input size="small" v-model="editForm.app_version" auto-complete="off" placeholder="Version" clearable="">
          </el-input>
        </el-form-item>
        <el-form-item label="APK" prop="app_version">
          <el-upload class="upload-demo" drag :action="upload_url" :headers="upload_header" :on-success="imageSuccess">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drag files here or <em>click to upload</em></div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    AutomaticAppList,
    AutomaticAppSave,
  } from '../../api/apiFun'
  import {
    timestampToTime,
    uploadUrl,
    getCookie
  } from '@/utils/util';
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        upload_url: uploadUrl(),
        upload_header: {
          Authorization: getCookie('dkh_token')
        },
        loading: false, //是显示加载
        editFormVisible: false, //控制Edit页面显示与隐藏
        title: 'Add',
        editForm: {
          id: '',
          country: '',
          app_version: '',
          download_url: '',
        },
        // rules 表单验证
        rules: {
          country: [{
            required: true,
            message: 'Country cannot be empty',
            trigger: 'blur'
          }],
          app_version: [{
            required: true,
            message: 'Version cannot be empty',
            trigger: 'blur'
          }],
          download_url: [{
            required: true,
            message: 'APK cannot be empty',
            trigger: 'blur'
          }],
        },
        params: {
          page: 1,
          limit: 20,
        },
        listData: [],
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 20
        }
      }
    },
    components: {
      Pagination
    },
    filters: {
      timestampToTime: function (timestamp) {
        return timestampToTime(timestamp)
      }
    },
    created() {
      this.getdata(this.params)
    },
    methods: {
      imageSuccess(response) {
        if (response.code == 200) {
          this.editForm.download_url = response.datas.url;
        } else {
          this.$message({
            type: 'info',
            message: response.msg
          })
        }
      },
      // 获取Automatic app list
      getdata(parameter) {
        this.loading = true
        AutomaticAppList(parameter).then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.datas.list
            // 分页赋值
            this.pageparm.currentPage = this.params.page
            this.pageparm.pageSize = this.params.limit
            this.pageparm.total = res.datas.count
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get the automatic app list, please try again later!')
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.params.page = parm.currentPage
        this.params.limit = parm.pageSize
        this.getdata(this.params)
      },
      // Search事件
      search() {
        this.params.page = 1
        this.getdata(this.params)
      },
      //显示Edit界面
      handleEdit: function (index, row) {
        this.editFormVisible = true

        if (row != undefined && row != 'undefined') {
          this.title = 'Edit'
          this.editForm.id = row.id
          this.editForm.country = row.country
          this.editForm.app_version = row.app_version
          this.editForm.download_url = row.download_url
        } else {
          this.title = 'Add'
          this.editForm.id = ''
          this.editForm.country = ''
          this.editForm.app_version = ''
          this.editForm.download_url = ''
        }
      },
      // Edit、增加页面Save方法
      submitForm(editData) {
        this.loading = true
        this.$refs[editData].validate(valid => {
          if (valid) {
            AutomaticAppSave(this.editForm).then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 200) {
                this.getdata(this.params)
                this.$message({
                  type: 'success',
                  message: 'Saved successfully'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            }).catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('Saving failed, please try again later!')
            })
          } else {
            return false
          }
        })
      },
      // closeEdit、增加弹出框
      closeDialog(dialog) {
        if (dialog == 'edit') {
          this.editFormVisible = false
        } else if (dialog == 'perm') {}
      },
    }
  }

</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/views/automatic_app/automatic_app_list.vue